<template>
  <div class="mx-3">
    <step-script-input
      :content="customHeaderContent"
      :instructions="customHeaderInstructions"
      :label-text="'Custom HTML header'"
      :name="'custom_scripts_head'"
      :step-id="stepId"
    ></step-script-input>
    <step-script-input
      :content="customFooterContent"
      :instructions="customFooterInstructions"
      :label-text="'Custom HTML footer'"
      :name="'custom_scripts_footer'"
      :step-id="stepId"
    ></step-script-input>
    <p>
      For any above input that is left empty, we will use the value set in the 
      <a href="/account/landing-pages/">landing pages</a> section of your account.
    </p>
    <hr>
    <notifications-emails
      v-if="showFormSubmissionNotifications"
      :url="'notifications/form-submissions/' + emailableType + '/' + emailableId"
      :emailable-type="emailableType"
      :emailable-id="emailableId"
      :form-submission-notifications-title="formSubmissionNotificationsTitle"
      :form-submission-notifications-description="formSubmissionNotificationsDescription"
      :no-results-message="noResultsMessage"
    ></notifications-emails>
  </div>
</template>

<script>
import {createCampaignStepPieceIndexesMap} from '../../../../utility/campaign/step/createCampaignStepPieceIndexesMap';
import StepScriptInput from './StepScriptInput';
import NotificationsEmails from "../../../account/notifications/NotificationsEmails";

export default {
  name: 'step-advanced-settings-form',
  components: {StepScriptInput, NotificationsEmails},
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    pieces: {
      type: Array,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
    showFormSubmissionNotifications: {
      type: Boolean,
      required: true,
    },
    formSubmissionNotificationsTitle: {
      type: String,
      required: true,
    },
    formSubmissionNotificationsDescription: {
      type: String,
      required: true,
    },
    emailableType: {
      type: String,
      required: true,
    },
    emailableId: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
    noResultsMessage: {
        type: String,
        required: false,
    },
  },
  data() {
    return {
      customHeaderContent: '',
      customFooterContent: '',
    };
  },
  computed: {
    customHeaderPiece() {
      return (this.pieces || []).find(piece => piece.name === 'custom_scripts_head');
    },
    customHeaderInstructions() {
      const {options} = this.customHeaderPiece || {};
      return (
        (options && options.instructions) ||
        'Code entered here will be placed before the closing &lt;/head&gt; tag on this landing page. This is a good spot for scripts like Facebook Pixel or Google Ads Tag.'
      );
    },
    customFooterPiece() {
      return (this.pieces || []).find(piece => piece.name === 'custom_scripts_footer');
    },
    customFooterInstructions() {
      const {options} = this.customFooterPiece || {};
      return (
        (options && options.instructions) ||
        'Code entered here will be placed before the closing &lt;/body&gt; tag on this landing page.'
      );
    },
    pieceIndexesMap() {
      return createCampaignStepPieceIndexesMap(this.pieces);
    },
  },
  watch: {
    customHeaderPiece: {
      immediate: true,
      handler(customHeaderPiece) {
        if (customHeaderPiece && !this.customHeaderContent) {
          this.customHeaderContent = customHeaderPiece.content;
        }
      },
    },
    customFooterPiece: {
      immediate: true,
      handler(customFooterPiece) {
        if (customFooterPiece && !this.customFooterContent) {
          this.customFooterContent = customFooterPiece.content;
        }
      },
    },
  },
};
</script>
<style lang="css">
.step-advanced-settings-modal .modal-body .form-group.VueTables__search {
  margin: auto auto 15px auto;
}
</style>
